<button
  type="button"
  class="online-carrier-info__trigger"
  aria-label="How online carriers are managed"
  (click)="panel.toggle($event)"
>
  <i class="pi pi-info-circle" aria-hidden="true"></i>
</button>
<p-popover
  appPopoverArrow
  #panel
  appendTo="body"
  styleClass="online-carrier-info-popover"
>
  <p class="online-carrier-info__text">
    Manage your carrier integrations in
    <strong>Settings → My Organization → Integrations.</strong>
    @if (organizationId()) {
      Click button below to view available options, or contact your Quotiss
      Administrator.
    } @else {
      Contact your Quotiss Administrator to view available options.
    }
  </p>
  @if (organizationId()) {
    <div class="online-carrier-info__actions">
      <button
        pButton
        type="button"
        size="small"
        [outlined]="true"
        class="online-carrier-info__button"
        (click)="panel.hide(); openIntegrations()"
      >
        My integrations <i class="pi pi-angle-right" aria-hidden="true"></i>
      </button>
    </div>
  }
</p-popover>
